<div class="file-upload-container">
  <p-fileUpload
    #uploader
    name="files"
    mode="basic"
    [customUpload]="true"
    multiple
    (onSelect)="onFileSelected($event)"
    [accept]="accpetType"
    [chooseLabel]="addFileLabel">
  </p-fileUpload>
    <div
      class="paste-drop-zone"
      tabindex="0"
      role="button"
      aria-label="Paste (Ctrl+V) or drop files here"
      (paste)="onPaste($event)"
      (dragover)="onDragOver($event)"
      (drop)="onDrop($event)"
    >
    <i class="pi pi-clipboard"></i>
    <span>Paste (Ctrl+V) or drop files here</span>
  </div>

  <ul class="uploaded-files-list">
    @for (file of uploadedFiles; track file) {
      <li>
        {{ file.name }}
        <button
          type="button"
          class="p-button-sm p-button-danger"
          (click)="confirmRemove(file)">
          Remove
        </button>
      </li>
    }
  </ul>

  <p-dialog
    [(visible)]="showFileDeleteDialog"
    [modal]="true"
    [dismissableMask]="true"
    [baseZIndex]="10000"
    [style]="{ width: 'min(90vw, 420px)' }"
    contentStyleClass="custom-confirm-dialog"
    (onHide)="cancelFileDeletion()">
    <div class="dialog-content">
      <i class="pi pi-exclamation-triangle warning-icon"></i>
      <span class="dialog-message">Are you sure you want to remove this file?</span>
    </div>
    <ng-template pTemplate="footer">
      <div class="dialog-footer">
        <button pButton class="no-button" type="button" (click)="cancelFileDeletion()">No</button>
        <button pButton class="yes-button" type="button" (click)="confirmFileDeletion()">Yes</button>
      </div>
    </ng-template>
  </p-dialog>
</div>
